import { API_URL } from "../../../../../constants";
import * as httpNetworking from "../../../../../httpNetworking";

const VERSION = 2;

export async function updateMultiTenancyApp(
    appId: string,
    data: {
        deploymentId: string;
        deploymentType: "development" | "production";
        config: { key: string; value: string }[];
        cancelURL: string;
        successURL: string;
    }
): Promise<void> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000
    };

    const url = API_URL + "/saas/multi-tenancy/connection-uri-domain/" + appId;

    await httpNetworking.simplePUTRequest(url, data, options, VERSION);
}
